export let SearchSuggestionDtoType;

(function (SearchSuggestionDtoType) {
  SearchSuggestionDtoType[SearchSuggestionDtoType["Brand"] = 0] = "Brand";
  SearchSuggestionDtoType[SearchSuggestionDtoType["Catalog"] = 1] = "Catalog";
})(SearchSuggestionDtoType || (SearchSuggestionDtoType = {}));

export let SearchSuggestionType;

(function (SearchSuggestionType) {
  SearchSuggestionType["Brand"] = "brand";
  SearchSuggestionType["Catalog"] = "catalog";
  SearchSuggestionType["Fallback"] = "frontend_generated";
  SearchSuggestionType["Scoped"] = "scoped";
  SearchSuggestionType["Multiword"] = "multiword";
})(SearchSuggestionType || (SearchSuggestionType = {}));

export let SearchBarSearchType;

(function (SearchBarSearchType) {
  SearchBarSearchType["Item"] = "item";
  SearchBarSearchType["User"] = "user";
  SearchBarSearchType["Forum"] = "forum";
  SearchBarSearchType["Faq"] = "faq";
})(SearchBarSearchType || (SearchBarSearchType = {}));

export const SEARCH_START_ID_KEY = 'searchStartId';
export const SEARCH_START_TYPE_KEY = 'searchStartType';
export const SEARCH_SESSION_ID_KEY = 'searchSessionId';
export const GLOBAL_SEARCH_SESSION_ID_KEY = 'globalSearchSessionId';